export default (amount, currency) => {
  const zeroDecimalCurrencies = [
    "bif",
    "clp",
    "djf",
    "gnf",
    "jpy",
    "kmf",
    "krw",
    "mga",
    "pyg",
    "rwf",
    "ugx",
    "vnd",
    "vuv",
    "xaf",
    "xof",
    "xpf"
  ];
  if (zeroDecimalCurrencies.includes(currency)) {
    return amount;
  } else {
    return parseFloat(amount / 100).toFixed(2);
  }
};
